"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brand = void 0;
var Brand;
(function (Brand) {
    Brand["JochenSchweizer"] = "Jochen Schweizer";
    Brand["JochenSchweizerArena"] = "Jochen Schweizer Arena";
    Brand["HipTrips"] = "HipTrips";
})(Brand = exports.Brand || (exports.Brand = {}));
//# sourceMappingURL=brand.js.map